"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Navbar;
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _utils = require("../../utils");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    icon: {
      fill: theme.palette.TwClrIcnSecondary,
      marginRight: '16px',
      marginBottom: '8px'
    },
    closeButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer'
    },
    navBarTop: {
      display: 'flex',
      justifyContent: 'start'
    }
  };
});
function Navbar(props) {
  var children = props.children,
    setShowNavBar = props.setShowNavBar,
    backgroundTransparent = props.backgroundTransparent;
  var _useDeviceInfo = (0, _utils.useDeviceInfo)(),
    isDesktop = _useDeviceInfo.isDesktop;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'navbar' + (backgroundTransparent ? ' transparent' : '')
  }, !isDesktop && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.navBarTop
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return setShowNavBar(false);
    },
    className: classes.closeButton
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "close",
    size: "medium",
    className: classes.icon
  }))), children);
}